import './statItem.scss';

import { FormattedMessage } from 'react-intl';

interface StatItemProps {
  icon: string;
  count: number;
  labelId: string;
  defaultMessage: string;
}

const StatItem = ({ icon, count, labelId, defaultMessage }: StatItemProps) => (
  <div className='StatItem'>
    <i className={`elibertyIcon-${icon}`} aria-hidden='true' />
    {count} <FormattedMessage id={labelId} defaultMessage={defaultMessage} />
  </div>
);

export default StatItem;
